import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AppNotification } from '@app/helpers';
import { AuthService, BrokerService } from '@app/services';

@Component({
  selector: 'app-broker-add',
  templateUrl: './broker-add.component.html',
  styleUrls: ['./broker-add.component.scss']
})
export class BrokerAddComponent implements OnInit {
  @Output() onDone: any = new EventEmitter();
  @Input() user: any;
  admin: any;

  constructor(
    private brokerService: BrokerService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.admin = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    }
    console.log(this.user)
    if (this.user != null) {
      this.admin = {
        firstName: this.user.user.firstName,
        lastName: this.user.user.lastName,
        email: this.user.user.email,
        phone: this.user.user.phone,
        isActive: this.user.user.isActive
      }
    }
  }

  onSaveHandler() {
    console.log(this.admin)
    if (this.user != null) {
      if (this.user.admin) {
        return this.authService.saveProfile({
          firstName: this.admin.firstName,
          lastName: this.admin.lastName,
          email: this.admin.email,
          phone: this.admin.phone,
        }).subscribe({
          next: (res: any) => {
            this.onDone.emit(res.data)
          },
          error: (error: any) => {
            AppNotification.error("Something went wrong!")
          },
        })
      }
      return this.brokerService.update(this.user._id, {
        firstName: this.admin.firstName,
        lastName: this.admin.lastName,
        email: this.admin.email,
        phone: this.admin.phone,
        isActive: this.admin.isActive
      }).subscribe({
        next: (res: any) => {
          this.onDone.emit(res.data)
        },
        error: (error: any) => {
          AppNotification.error("Something went wrong!")
        }
      })
    }
    return this.brokerService.add(this.admin).subscribe({
      next: (res: any) => {
        this.onDone.emit(res.data)
      },
      error: (error: any) => {
        AppNotification.error("Something went wrong!")
      }
    })
  }

  onBrokerChanged() {

  }

}
